<ng-container *ngIf="updateIntegrationPause$ | async"></ng-container>
<ng-container *ngIf="dialogRef$ | async"></ng-container>

<div
  [class.disable-hover]="disableHover"
  class="integration-status-item"
  *ngIf="integration"
  [ngClass]="{
    'is-selected': selected,
    selectable: selectable,
  }"
  (click)="handleBannerClicked()">
  <div class="integration-status-item-body">
    <div class="integration-status-item-left-hand">
      <div class="integration-status-item-icon">
        <img [src]="logo | safe" (error)="logo = getPlaceholderLogo()" />
      </div>
      <div class="integration-status-item-title-block">
        <div class="integration-status-item-name">
          {{ integration.friendly_name }}
        </div>
        <div class="integration-status-item-state">
          {{ integration.generatedState }}
          <span *ngIf="integration.autoimport_age">
            (Automatic Import:
            {{ integration.autoimport_age.age }}
            {{ integration.autoimport_age.scale | translation }})
          </span>
        </div>
      </div>
    </div>
    <!--  -->
    <div class="integration-status-item-buttons">
      <app-button
        *ngIf="canTogglePauseState"
        status="link"
        class="integration-status-item-pause-button"
        (click)="togglePauseState($event)"
        [disabled]="integration.isUpdating"
        (mouseenter)="disableHover = true"
        (mouseleave)="disableHover = false">
        <i
          class="fa-thin"
          [ngClass]="{
            'fa-circle-pause': !integration.paused,
            'fa-circle-play': integration.paused,
          }"></i>
        <ng-container *ngIf="integration.paused">{{
          'resume_imports' | translation
        }}</ng-container>
        <ng-container *ngIf="!integration.paused">{{
          'pause_imports' | translation
        }}</ng-container>
      </app-button>
      <app-button
        status="link"
        class="integration-status-item-pause-button"
        *ngIf="showEditIconVisible"
        (click)="handleEditClick($event)"
        (mouseenter)="disableHover = true"
        (mouseleave)="disableHover = false">
        <i class="fa-solid fa-pencil"></i>
        {{ 'edit' | translation }}
      </app-button>
    </div>
    <div *ngIf="syncDetails" class="integration-status-item-course-exists">
      <p *ngIf="integration.is_source">{{ 'source' | translation }}</p>
      <p *ngIf="!integration.is_source">
        {{ 'course_exists' | translation }}:
        {{ (integration.has_course ? 'yes' : 'no') | translation }}
      </p>
    </div>
  </div>
  <div class="integration-status-item-footer">
    <div
      class="integration-status-item-type"
      [style]="getTypeColor(integration) | safeStyle">
      {{ integration.integration_type | transformText: 'uppercase' }}
    </div>
    <div class="integration-status-item-integration-type">
      {{ getSystemType() | transformText: 'capitalize' }}
      {{ 'integration' | translation | transformText: 'capitalize' }}
    </div>
    <div class="integration-status-item-status">
      <div class="integration-status-item-status-wrapper">
        <div class="integration-status-item-status-icon">
          <i
            class="fa-solid fa-circle"
            [ngClass]="{
              active: integration.generatedStatus === 'valid',
              inactive: integration.generatedStatus === 'offline',
              error: integration.generatedStatus === 'error',
            }"></i>
        </div>
        <div
          class="integration-status-item-status-text"
          (click)="handleInfoClick($event)"
          style="cursor: pointer">
          <strong>{{ 'status' | translation }}: </strong>

          <span class="text-transform-capitalize">{{
            integration.generatedStatus | translation
          }}</span>
        </div>
        <button
          (mouseenter)="disableHover = true"
          (mouseleave)="disableHover = false"
          *ngIf="showInfoIcon"
          class="integration-status-item-status-info-button"
          (click)="handleInfoClick($event)">
          <i class="fa-solid fa-circle-info text-link-color"></i>
        </button>
      </div>
    </div>

    <div class="integration-status-item-updated-at">
      {{ 'updated' | translation | transformText: 'capitalize' }}:
      {{ integration.updated_at | localizeDate: 'MM/dd/yyyy hh:mma' }}
    </div>
    <div
      *ngIf="canRefreshState"
      (mouseenter)="disableHover = true"
      (mouseleave)="disableHover = false"
      class="text-link-color integration-status-item-refresh"
      [ngClass]="{
        'rotate-animation':
          integration?.isRefreshing || integration?.status === 'processing',
      }"
      (click)="handleRefreshClick($event)">
      <i class="fa-regular fa-arrows-rotate"></i>
    </div>
  </div>
</div>
